import axios from 'axios';

const client = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}/vyte-event`,
  withCredentials: true,
});

export default client;
